import React from 'react';
import Automations from '../Automations/Automations';

function ScheduledBot() {
  return <Automations openType="scheduled" />;
}

export default ScheduledBot;